import React, { useMemo } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

// companyOptions: [{ Id, value, label }]; sellerOptions: [{ companyId, sellerId, sellerName, ... }]
const CompanySellerPicker = ({ companyOptions, sellerOptions, companyId, sellerId, onChange }) => {
  const sellersOfCompany = useMemo(
    () => sellerOptions
      .filter((s) => s.companyId === companyId)
      .map((s) => ({ value: s.sellerId, label: s.sellerName, companyId: s.companyId })),
    [sellerOptions, companyId]
  );

  const selectedCompany = companyOptions.find((c) => c.Id === companyId) || null;
  const selectedSeller = sellersOfCompany.find((s) => s.value === sellerId) || null;

  const handleCompany = (option) => {
    const nextCompanyId = option ? option.Id : null;
    const sellers = sellerOptions.filter((s) => s.companyId === nextCompanyId);
    // Single-seller company: preselect it.
    onChange({ companyId: nextCompanyId, sellerId: sellers.length === 1 ? sellers[0].sellerId : null });
  };

  return (
    <>
      <div className="mb-3">
        <label className="labelHead" htmlFor="unassigned-company-select">Company *</label>
        <Select
          inputId="unassigned-company-select"
          value={selectedCompany}
          onChange={handleCompany}
          options={companyOptions}
          className="react-select-container"
          classNamePrefix="react-select"
          placeholder="Select Company..."
          isClearable
        />
      </div>
      <div className="mb-3">
        <label className="labelHead" htmlFor="unassigned-seller-select">Seller *</label>
        <Select
          inputId="unassigned-seller-select"
          value={selectedSeller}
          onChange={(option) => onChange({ companyId, sellerId: option ? option.value : null })}
          options={sellersOfCompany}
          className="react-select-container"
          classNamePrefix="react-select"
          placeholder="Select Seller..."
          isDisabled={!companyId}
          isClearable
        />
      </div>
    </>
  );
};

CompanySellerPicker.propTypes = {
  companyOptions: PropTypes.array.isRequired,
  sellerOptions: PropTypes.array.isRequired,
  companyId: PropTypes.number,
  sellerId: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default CompanySellerPicker;
